import { Autocomplete, Grid } from "@mui/material";
import AloveAutocomplete from "components/alove/AloveAutocomplete";
import { Content } from "models/content/Content";
import { GeneralCode, GeneralCodeType } from "models/content/GeneralCode";
import { useEffect, useState } from "react";
import { getGeneralCodes } from "utils/generalCodesUtils";

const MDInput = require("components/MDInput/index.js").default;

export const ContentInfo = ({
  content,
  setContent,
}: {
  content: Content;
  setContent: (content) => void;
}) => {
  const [categories, setCategories] = useState([] as GeneralCode[]);
  useEffect(() => {
    getGeneralCodes(GeneralCodeType.ContentCategory).then((categories) =>
      setCategories(categories)
    );
  }, []);
  return (
    <Grid container spacing={2}>
      <Grid
        size={{
          md: 4
        }}>
        <MDInput
          label="Title"
          fullWidth
          value={content.name || ""}
          onChange={(e) => setContent({ ...content, name: e.target.value })}
          required
        />
      </Grid>
      <Grid
        size={{
          md: 4
        }}>
        <AloveAutocomplete
          options={categories}
          getOptionLabel={(option) => option.name}
          renderInput={(params) => <MDInput {...params} label="Category" />}
          value={categories.find((c) => c.id == content.categoryId) || null}
          onChange={(e, v) => setContent({ ...content, categoryId: v?.id })}
        />
      </Grid>
      <Grid
        size={{
          md: 12
        }}>
        <MDInput
          label="Tags"
          placeholder="Tags (comma separated)"
          fullWidth
          value={content.tags?.join(",") || ""}
          onChange={(e) => setContent({ ...content, tags: e.target.value.split(",") })}
        />
      </Grid>
    </Grid>
  );
};
